import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Fade from 'react-reveal/Fade';
import CompPositions from '../comp-positions.jsx';
import {Helmet} from 'react-helmet';
import ModalVideo from 'react-modal-video';

class WorkAtBethard extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
  }

  openModal () {
    this.setState({isOpen: true})
  }

  componentDidMount () {
    var section = document.getElementById("section");

    function calcVH() {
      var vH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        section.setAttribute("style", "height:" + vH + "px;");
      }

    calcVH();

    window.addEventListener('onorientationchange', calcVH, true);

    window.scrollTo(0, 0)
    var header = document.getElementById("navigation");
    header.classList.remove('active');
    header.style.top = "0";
  }

  render() {

    return (
      <div className="single-page work" id="single-page">

        <Helmet>
          <title>Work at Bethard</title>
          <link rel="canonical" href={location.protocol + '//' + location.host} />
          <meta property="og:title" content="Work at Bethard" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={location.href} />
          <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
        </Helmet>
        <Fade duration={1200} delay={0}>
          <div className="content-wrapper background" id="section">
            <div className="section-content">
              <div className="icon-scroll"></div>
              <h1 className="section-subheading">Work at Bethard</h1>
              <div className="section-heading">Working at Bethard</div>
              <div className="section-heading">has its perks</div>
            </div>
          </div>
        </Fade>
        <div className="content-wrapper light">
          <div className="section-content">
            <h2>Why Bethard</h2>
            <div className="section-heading">Why work</div>
            <div className="section-heading">at Bethard</div>
            <p className="bread">We develop people by giving them the opportunity to develop themselves, surrounding them with inspiring colleagues and giving them big challenges to work on.</p>
            <p className="bread">
            We are not like others. We don't waste time bragging about ourselves, how good we are, how our brand is different from others or how our product is the best in the world. Instead we focus on getting the job done, making sure we actually deliver on all these things. We believe that the end result will speak for itself.</p>
          </div>
        </div>

        <div className="content-wrapper image">
          <img src="/img/a-great-place-to-work.jpg" />
        </div>


        <div className="content-wrapper light two first">
          <div className="section-wrapper">
            <div className="section-content two image">
              <img src="../img/igaminglogob2x.png" />
            </div>
            <div className="section-content two">
              <h2 className="margin">Employer of the year</h2>
              <p className="bread">The iGaming Idol Awards is an award show created to recognise top talent and best companies in the gaming industry in Malta. It is the only award show in the iGaming industry which recognises both individuals and companies or projects for their outstanding performance and talent in their respective categories.</p>
              <p className="bread">For the second year in a row, companies had the option to participate in Business Leaders Malta’s Employee's Voice. This is a category based on independent research which benchmarks employee engagement and satisfaction across various areas within different sectors. Companies were judged through a survey distributed to the employees of each participating company.</p>
              <p className="bread">Bethard consists of a team of passionate individuals with a vision to create and promote extraordinary iGaming brands. We are proud of what we create, and we love to work together. This is what came through in the survey, and what makes Bethard Employer of the Year.</p>
            </div>
          </div>
        </div>

        <div className="content-wrapper light two">
          <div className="section-wrapper">
            <div className="section-content two image">
              <img src="../img/award_transparant.png" />
            </div>
            <div className="section-content two">
              <h2 className="margin">A great place to work</h2>
              <p className="bread">In February 2018, Bethard was named a 'Great Place to Work' at the prestigious International Gaming Awards (IGA) in London. The ceremony celebrates exceptional achievement in the gambling industry. The event attracts industry professionals from the world's leading companies, praising operational excellence and innovation.</p>
              <p className="bread">
                We are thrilled to have won this award, the one that means the most to us, being recognized as a great place to work. We believe that we can only be a truly great company if we have the best possible team. The Bethard team delivers our amazing gaming experience and is responsible for growing our player base, month by month, year by year.</p>
              <p className="bread">
                The Bethard concept is to empower its employees and replacing pyramids with a smarter, faster structure with more freedom but also with clear accountability. It might sound flat; it's not, it's great, and places the right amount of power and responsibility in the hands of whoever needs it.
              </p>

              <p className="bread">
                The dynamic structure allows everyone to create an idea and run with it, while team coaches keep an eye on overall performance. Bethard's marketing slogan is 'winners dare more', which is well aligned with the company culture of 'having fun, daring and winning' in the workplace.
              </p>
            </div>
          </div>
        </div>

        <div className="content-wrapper dark">
          <div className="ul-wrapper">
            <h2 className="article-heading">Work benefits</h2>
            <div className="article-heading">Winners</div>
            <div className="article-heading">deserve</div>
            <div className="article-heading-white">more<span>™</span></div>
            <ul>
              <li>
                <img src="/img/benefits-01_salaries_toptalent.jpg" />
                <div className="bullet-content">
                  <h3>Competitive salaries</h3>
                  <p>Talent is rewarded</p>
                </div>
              </li>
              <li>
                <img src="/img/benefits-02_support_loyalty.jpg" />
                <div className="bullet-content">
                  <h3>Loyalty Bonus</h3>
                  <p>Support and payment staff are rewarded with €1500 for every year of service</p>
                </div>
              </li>
              <li>
                <img src="/img/benefits-03_health_benefit.jpg" />
                <div className="bullet-content">
                  <h3>Health benefits</h3>
                  <p>€250 to spend on your health + private health & life insurance</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="content-wrapper light">
          <div className="section-content">
            <h2>This is Malta</h2>
            <div className="section-heading">Live & work in</div>
            <div className="section-heading">the sunniest</div>
            <div className="section-heading">place in Europe</div>
            <p className="bread">Besides the sun, low taxes, low crime rates and the spectacular scenery, Malta offers something much more personal: a great journey. At work and during spare time. Regardless of whether you move here alone or bring the whole family, everyone will find new friends here; friends at work and friends through work to help you grow and explore life on this pearl of an island.</p>
          </div>
        </div>
        <div className="content-wrapper image">
          <img src="/img/01_malta_stjulian.jpg" />
        </div>
        <div className="content-wrapper image">
          <img src="/img/office_selfie.jpg" />
        </div>
        <div className="content-wrapper image">
          <img src="/img/03_football.jpg" />
        </div>
        <div className="content-wrapper light three">
          <div className="section-wrapper">
            <div className="section-content">
              <div className="article-heading-wrapper">
                <div className="article-heading">Ready</div>
                <div className="article-heading">For</div>
                <div className="article-heading">Malta?</div>
              </div>
              <div className="article-text-wrapper">
                  <p className="bread">With an amazing outdoor climate, and bursting with top notch five star hotels, there are plenty of sports and fun you can do all year round. Golf, Scuba diving, Yoga, Boxing, Water Polo, BMX, Karate, BJJ, Thai Boxing, Football, Tennis, Squash, Biking, Boating, Swim-Run – just to mention a few. </p>
                <p className="bread nomargin">Malta is small, but offers great experiences and opportunities to all who want more out of work and life. Dont believe? Just check out these great stats:</p>
                <ul>
                  <li>300 - 330 days of sunshine</li>
                  <li>Lowest taxes in Europe</li>
                  <li>Lowest crime rate in Europe</li>
                </ul>
              </div>

            </div>
          </div>
        </div>
        <div className="content-wrapper light">
          <div className="section-content">
            <h2>Location</h2>
            <div className="section-heading">Bethard's</div>
            <div className="section-heading">home turf</div>
            <p className="bread">Our headquarters are based in the <strong>centre of Paceville – right in the heart of fun!</strong></p>
            <p className="bread nomargin">
            Naturally we want you to feel on top when you’re at work.  That’s why we’ve equipped the office with a play station, a billiard table, a dart board and a table tennis together with a fully fledged kitchen. We’ve also included both indoor and outdoor chill zones as well as coffee and tea facilities.
		</p>

          </div>
        </div>
        <CompPositions/>
      </div>
    );
  }
}

export default WorkAtBethard;



// WEBPACK FOOTER //
// ./client/components/pages/work-at-bethard.jsx